import AnimatedCheckmark from 'components/AnimatedCheckmark'
import React from 'react'
import toast, { Toast } from 'react-hot-toast'

interface Props {
	t: Toast
}

export default function QuoteUpdatedFirst({ t }: Props) {
	return (
		<div className="flex w-full max-w-md rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5">
			<div className="w-0 flex-1 p-4">
				<div className="flex items-center">
					<AnimatedCheckmark size="xs" />
					<div className="ml-3 flex-1">
						<p className="text-sm font-medium text-slate-900">Your quote has been updated.</p>
						<p className="mt-1 text-sm text-slate-500">
							Your quote is automatically updated when you change the quantity of a product.
						</p>
					</div>
				</div>
			</div>
			<div className="flex border-l border-slate-200">
				<button
					onClick={() => toast.remove(t.id)}
					className="flex w-full items-center justify-center rounded-none rounded-r-lg border border-transparent p-4 text-sm font-medium text-ab-100 hover:text-ab-200 focus:outline-none focus:ring-2 focus:ring-ab-100"
				>
					Close
				</button>
			</div>
		</div>
	)
}
